<div class="local-table-toolbar">
  <mat-form-field appearance="outline" class="local-search-field">
    <mat-label>Pesquisar filial</mat-label>
    <input matInput [(ngModel)]="searchTerm" />
    <mat-icon matSuffix>search</mat-icon>
  </mat-form-field>
  <button *ngIf="!readonly" type="button" mat-mini-fab class="btn-add" aria-label="Adicionar filial" (click)="open()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<p class="empty" *ngIf="!rows.length">Nenhuma filial encontrada.</p>

<table mat-table [dataSource]="rows" *ngIf="rows.length" class="related-table">
  <ng-container matColumnDef="title">
    <th mat-header-cell *matHeaderCellDef>FILIAL</th>
    <td mat-cell *matCellDef="let row">
      {{ row.branchTitle }}
      <span class="matriz" *ngIf="isMatriz(row)">MATRIZ</span>
    </td>
  </ng-container>
  <ng-container matColumnDef="document">
    <th mat-header-cell *matHeaderCellDef>DOCUMENTO</th>
    <td mat-cell *matCellDef="let row">{{ row.branchDocument || '—' }}</td>
  </ng-container>
  <ng-container matColumnDef="city">
    <th mat-header-cell *matHeaderCellDef>CIDADE/UF</th>
    <td mat-cell *matCellDef="let row">{{ row.branchCity || '—' }}<span *ngIf="row.branchState"> / {{ row.branchState }}</span></td>
  </ng-container>
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef>STATUS</th>
    <td mat-cell *matCellDef="let row">{{ status(row) }}</td>
  </ng-container>
  <ng-container matColumnDef="actions">
    <th mat-header-cell *matHeaderCellDef></th>
    <td mat-cell *matCellDef="let row" class="row-actions">
      <button type="button" mat-icon-button aria-label="Ver filial" (click)="open(row, true)">
        <mat-icon class="btn-show">visibility</mat-icon>
      </button>
      <button *ngIf="!readonly" type="button" mat-icon-button aria-label="Editar filial" (click)="open(row)">
        <mat-icon class="btn-edit">edit</mat-icon>
      </button>
      <button *ngIf="!readonly && !isMatriz(row)" type="button" mat-icon-button aria-label="Excluir filial" (click)="remove(row)">
        <mat-icon class="btn-delete">delete</mat-icon>
      </button>
    </td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
